import { CodeBase } from "./_codeBase";

/** 入力形式区分区分*/
export class InputTypeDiv extends CodeBase<InputTypeDiv>
{
    /** 入力形式区分: "01", "文字列", ""*/
    public static readonly STRING = new InputTypeDiv("01", "文字列", "");

    /** 入力形式区分: "02", "数値のみ" ""*/
    public static readonly NUMBER: InputTypeDiv = new InputTypeDiv("02", "数値のみ", "");

    /** 入力形式区分: "03", "日付", ""*/
    public static readonly DATE: InputTypeDiv = new InputTypeDiv("03", "日付", "");

    /** 入力形式区分: "04", "時刻", ""*/
    public static readonly DATETIME: InputTypeDiv = new InputTypeDiv("04", "時刻", "");


    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): InputTypeDiv[] {
        return [
            InputTypeDiv.STRING,
            InputTypeDiv.NUMBER,
            InputTypeDiv.DATE,
            InputTypeDiv.DATETIME,


        ];
    }
}